import mapStyles from './map-style-changer.styles';

const MAX_GEOLOCATION_TRIES = 5;

function waitForDrupalGeolocation(onSuccess, onError, tries = 0) {
  if (Drupal.hasOwnProperty('geolocation')) {
    if (typeof onSuccess === 'function') {
      onSuccess();
    }
  } else if (tries >= MAX_GEOLOCATION_TRIES) {
    if (typeof onError === 'function') {
      onError();
    }
  } else {
    setTimeout(() => {
      waitForDrupalGeolocation(onSuccess, onError, tries + 1);
    }, 1000);
  }
}

export default class MapStyleChanger {
  static changeMapStyles() {
    Drupal.geolocation.maps.forEach((map) => {
      if (map.hasOwnProperty('googleMap')) {
        map.googleMap.setOptions({ styles: mapStyles });
      }
    });
  }

  init() {
    jQuery(window).on('load', () => {
      waitForDrupalGeolocation(() => {
        MapStyleChanger.attach();
      });
    });

    return this;
  }

  static attach() {
    if (typeof Drupal.geolocation.addCallback !== 'undefined') {
      Drupal.geolocation.addCallback(() => {
        MapStyleChanger.changeMapStyles();
      });
    }

    MapStyleChanger.changeMapStyles();
  }
}
